module.exports = __webpack_public_path__ + "img/head_bg_syj.12577f3e.png";